import React from 'react';
import PropTypes from 'prop-types';

export default class MobileMapDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.statesList = Object.keys(this.props.states).sort();

    this.state = {
      selectValue: '',
    };

    this.stateCreationClickHandler = () => {
      if (this.state.selectValue) {
        window.location.assign(`${window.location.origin}/${this.state.selectValue}-${this.props.page.slug}`);
      }
    };

    this.handleSelectChange = (e) => {
      this.setState({ selectValue: e.target.value });
    };

    this.renderMobileTooltip = () => {
      if (this.state.selectValue) {
        return (
          this.props.renderMobileTooltipTemplate({
            tooltipRegion: this.state.selectValue,
            ...this.props,
          })
        );
      }

      return (<ul />);
    };

    this.prettyPrintString = state =>
       state.replace('-', ' ').split(' ').map(word =>
        word[0].toUpperCase() + word.substr(1),
      ).join(' ');
  }

  render() {
    return (
      <div
        className="state-dropdown-wrapper"
      >
        {this.props.mobileSelectHeaderTemplate}
        <select
          defaultValue={this.state.selectValue}
          onChange={this.handleSelectChange}
        >
          <option value="" disabled>Select State</option>
          {
            this.statesList.map(value =>
              <option value={value.toLowerCase()} key={value.toLowerCase()}>
                {this.prettyPrintString(value)}
              </option>,
            )
          }
        </select>
        <div className={`mobile-tooltip interactive-map-tooltip ${!this.state.selectValue ? 'hidden' : ''}`}>
          {this.renderMobileTooltip()}
        </div>
        {this.props.renderMobileSelectFooterTemplate(this.stateCreationClickHandler)}
      </div>
    );
  }
}

MobileMapDropdown.propTypes = {
  page: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    document_name: PropTypes.string.isRequired,
  }).isRequired,
  states: PropTypes.shape({
  }).isRequired,
  renderMobileTooltipTemplate: PropTypes.func.isRequired,
  mobileSelectHeaderTemplate: PropTypes.element.isRequired,
  renderMobileSelectFooterTemplate: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/UsaMap/components/MobileMapDropdown.jsx